// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OpayPaymentResult_wrapper__E7ie9"};